import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StatutLot } from 'src/app/models/StatutLot';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatutLotService {

  
private PATH_STATUT = "/programmes-lots/statut-lot/all";

constructor(private http: HttpClient) { }

getAllStatutLot = (): Observable<StatutLot[]> => {
  let url = environment.host.domaine + this.PATH_STATUT;
  return this.http.get<StatutLot[]>(url)
  }
}